import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonType } from '../../../shared/enums/button-type.enums';

import MenuItem from '../../../shared/interfaces/menuItems.interface';
import { IconComponent } from '../../atoms/icon/icon.component';
import LinkType from '../../../shared/enums/link-type.enums';
import { HrefType } from '../../../shared/enums/href-type.enums';

@Component({
  selector: 'hdi-navigation',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent {
  protected readonly ButtonType = ButtonType;
  protected readonly LinkType = LinkType;
  protected readonly HrefType = HrefType;
  protected isMobile: boolean = false;
  protected activeTitle: string = '';
  @Input() logoLocation: string = '';
  @Input() iconName: string = 'arrow-right-long';
  @Input() title: string = '';
  @Input() metaMenu: Array<MenuItem> = [];
  @Input() mainMenu: Array<MenuItem> = [];

  setActive = (title: string): void => {
    if (this.activeTitle === title) {
      this.activeTitle = '';
      return;
    }
    this.activeTitle = title;
  };
}
